export default __webpack_public_path__ + "static/media/Management-Fee.0a28b6e9.svg";